// utils
import { firstLastWords } from '@/utils/';
import { roleList } from '@/configs/const';

const firstAndLastName = state => ( state.user.name
    ? firstLastWords( state.user.name )
    : '' );

const freeswitchCredentials = state => state.user.freeswitchCredentials;

const getRole = state => roleList[state.user.role?.id];
const userId = state => state.user.id;
const isSameUser = state => id => state.user.id === id;

export default {
    firstAndLastName,
    freeswitchCredentials,
    getRole,
    userId,
    isSameUser
};